/* global grecaptcha -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import 'slick-carousel';

const $form = $('#scholarship-form');
const parsley = $form.parsley();

window.onGoogleReCaptchaCallback = function() {
    $form[0].submit();
};

$form.on('submit', function (event) {
    event.preventDefault();

    parsley.whenValidate()
        .done(() => {
            grecaptcha.execute();
        });
});

$('#winner-carousel-track').slick({
    appendDots: $('#winner-carousel-indicators'),
    dots: true,
    infinite: true,
    lazyLoad: 'ondemand',
    nextArrow: $('#winner-carousel-next'),
    prevArrow: $('#winner-carousel-prev'),
    slidesToScroll: 1,
    slidesToShow: 1,
});
